import React from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { baseURL } from '../api/baseURL';

/**
 * Admin toggle for maintenance_mode (on the shared MiscData singleton).
 * Both mobile apps check this — a fresh app open blocks within ~1-2 minutes
 * (app-store/CDN + client polling latency), and an already-open session picks
 * it up on its next periodic /misc fetch (see CheckAuth.tsx in each app).
 */
class MaintenanceModeToggle extends React.Component<{ token?: string }, { enabled: boolean, requested: boolean }> {
    state = { enabled: false, requested: false };

    componentDidMount(): void {
        if (!this.props.token) return;
        axios.get(`${baseURL}/maintenance-mode`, { headers: { Authorization: `Bearer ${this.props.token}` } })
            .then((response: any) => {
                if (response?.data?.message === 'success') {
                    this.setState({ enabled: !!response.data.maintenance_mode });
                }
            })
            .catch(() => {});
    }

    toggle = () => {
        if (this.state.requested || !this.props.token) return;
        const next = !this.state.enabled;
        const confirmMsg = next
            ? 'Turn maintenance mode ON? This blocks Customer/Photographer app access (takes 1-2 min to reach an already-open session).'
            : 'Turn maintenance mode OFF? This restores Customer/Photographer app access.';
        if (!window.confirm(confirmMsg)) return;
        this.setState({ requested: true });
        axios.post(`${baseURL}/set-maintenance-mode`, { enabled: next }, { headers: { Authorization: `Bearer ${this.props.token}` } })
            .then((response: any) => {
                if (response?.data?.message === 'success') {
                    this.setState({ enabled: !!response.data.maintenance_mode });
                }
            })
            .catch(() => {})
            .finally(() => this.setState({ requested: false }));
    }

    render(): React.ReactNode {
        return (
            <li className="nav-item menu-items">
                <a className="nav-link" href="#maintenance" onClick={(e) => { e.preventDefault(); this.toggle(); }} title="Blocks Customer/Photographer app access when ON — takes 1-2 min to reach an already-open session">
                    <span className="menu-icon">
                        <i className="mdi mdi-wrench-outline"></i>
                    </span>
                    <span className="menu-title" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        Maintenance Mode
                        <span
                            style={{
                                fontSize: 10, fontWeight: 700, padding: '2px 8px', borderRadius: 10,
                                color: '#fff', background: this.state.enabled ? '#dc3545' : '#28a745',
                            }}
                        >
                            {this.state.enabled ? 'ON' : 'OFF'}
                        </span>
                    </span>
                </a>
            </li>
        );
    }
}

const mapStateToProps = (state: any) => ({
    token: state.auth?.token,
});

export default connect(mapStateToProps)(MaintenanceModeToggle);
